module.exports = __webpack_public_path__ + "img/show_tc_text_14.3612b821.png";